/**
 * Helper functions for attributes handling
 */
import { parseAttributeString } from "./index";
import { TAttributeParam, TParserAttribute, TParserAttributes } from "./types";
let periodId = 1;
let internalPeriodID: Record<string, string> = {};
export const getAttributeInternalPeriodID = (periodName: string) => {
  if (!internalPeriodID[periodName]) {
    internalPeriodID[periodName] = String(periodId);
    periodId += 1;
  }
  return internalPeriodID[periodName];
};
/**
 *
 * This function will add attribute query for each period in the query
 *
 * @param params
 */
export const statusForEachPeriod = (params: TParserAttributes) => {
  const periodHasBeenInserted: Record<string, boolean> = {};
  const newAttributes: TParserAttribute[] = [];
  params.list.forEach((attr) => {
    if (attr.namedParameters.period) {
      const p = attr.namedParameters.period;
      if (p.tag === "string" || p.tag === "token") {
        if (!periodHasBeenInserted[p.value]) {
          periodHasBeenInserted[p.value] = true;
          const p_id = getAttributeInternalPeriodID(p.value);
          const seriesAttr: TAttributeParam = {
            tag: "string",
            name: "series",
            value: "STATUS",
          };
          const periodAttr: TAttributeParam = {
            tag: "string",
            name: "period",
            value: p.value,
          };
          const asAttr: TAttributeParam = {
            tag: "string",
            name: "as",
            value: `status_${p_id}`,
          };
          const attr: TParserAttribute = {
            name: "value",
            parameters: [seriesAttr, periodAttr, asAttr],
            namedParameters: {
              series: seriesAttr,
              period: periodAttr,
              as: asAttr,
            },
          };
          newAttributes.push(attr);
        }
      }
    }
  });
  return newAttributes;
};
export const attributeAlreadyExists = (
  params: TParserAttributes,
  item: TParserAttribute
) => {
  return params.list.find((listItem) => {
    if (
      listItem.name === item.name &&
      listItem.parameters.length === 0 &&
      item.parameters.length === 0
    ) {
      return true;
    }
    let { name } = item;
    const asParam = item.namedParameters.as;
    if (asParam && asParam.tag === "string") {
      name = asParam.value;
    }
    if (asParam && asParam.tag === "token") {
      name = asParam.value;
    }
    if (params.queryResultNames[name]) {
      return true;
    }
    return false;
  });
};
export const addAttributes = (
  params: TParserAttributes,
  list: TParserAttribute[]
) => {
  const res: TParserAttributes = {
    list: [...params.list],
    queryResultNames: { ...params.queryResultNames },
  };
  const finalList = list.filter(
    (item) => !attributeAlreadyExists(params, item)
  );
  finalList.forEach((item) => {
    res.list.push(item);
  });
  finalList.forEach((item) => {
    if (item.namedParameters.as) {
      const np = item.namedParameters.as;
      if (np.tag === "string") {
        res.queryResultNames[np.value] = item;
      }
      if (np.tag === "token") {
        res.queryResultNames[np.value] = item;
      }
    } else {
      res.queryResultNames[item.name] = item;
    }
  });
  return res;
};
export const createAttributesFromString = (value: string) => {
  const res = parseAttributeString(value);
  return res.list;
};
